import { path, pathOr } from 'ramda'
import React from 'react'

import { useServiceOrder } from '../_load/ServiceOrderLoader'

const EXECUTION_STATUSES = ['received', 'pause', 'execution', 'open', 'pending']

export const useIsEditing = () => {
  const serviceOrder = useServiceOrder()
  return React.useMemo(() => {
    const statusName = path(['status', 'name'], serviceOrder)
    // Uma atividade pausada está sempre em execução (retomada), mesmo que já
    // tenha sido concluída antes — caso contrário o rodapé mostra só "Salvar"
    // em vez de "Pausar" e "Enviar".
    if (statusName === 'pause') return false
    const wasCompletedBefore = pathOr([], ['events'], serviceOrder).some(
      event => path(['status', 'name'], event) === 'completed'
    )
    if (wasCompletedBefore) return true
    return !EXECUTION_STATUSES.includes(statusName)
  }, [serviceOrder])
}
